import { useState } from "react";
import { useForm } from "react-hook-form";

import useFetchWrapper from "../../Helpers/useFetchWrapper";

import { Props } from "./ChangePassword.model";

export const useChangePassword = ({onClose}: Props) => {
  const [passwordStrength, setPasswordStrength] = useState('weak');
  const { put } = useFetchWrapper();
  
  const { control, formState: { errors }, handleSubmit, watch } = useForm({
    defaultValues: {
      newPassword: '',
      oldPassword: '',
      repeatPassword: ''
    }
  });

  const watchPassword = watch('newPassword');

  const onPasswordChange = (event: any) => {
		const { value } = event.currentTarget;

		if (/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/.test(value)) {
			setPasswordStrength('strong');
		}	else if (/(?=.*[a-z])(?=.*[0-9])(?=.{8,})/.test(value)) {
			setPasswordStrength('medium');
		} else {
			setPasswordStrength('weak');
		}
  }
  
  const onSubmitPasswordForm = (data: any) => {
    updatePassword(data);
    onClose();
  }

  const updatePassword = async (data: any) => {
    const { oldPassword, newPassword } = data;
    await put('/user/settings/password', { newPassword, oldPassword });
  }

  return {
    control,
    errors,
    handleSubmit,
    onPasswordChange,
    onSubmitPasswordForm,
    state: { passwordStrength },
    watchPassword
  }
}